import qs from 'query-string'
import { useContext, useMemo } from 'react'
import { useLocation, useHistory } from 'react-router-dom'

import { useAnalytics } from 'legacy/containers/LoadsPage/hooks/useAnalytics'
import { LoadBoardContext } from 'legacy/contexts/loadBoard'

import { useConfigContext } from 'config/ui/ConfigContext'

import { OnboardingStep, getOnboardingStep } from '../../domain/RMISOnboarding'
import { RMISOnboardingDialog } from './RMISOnboardingDialog'

export const expectedQueryParamNames = ['finishOnboarding']

const analyticsLabels: Record<OnboardingStep, { step: string; confirm: string; cancel: string }> = {
  [OnboardingStep.Pending]: {
    step: 'Pending',
    confirm: 'Go to RMIS',
    cancel: 'Cancel',
  },
  [OnboardingStep.UnderReview]: {
    step: 'Under Review',
    confirm: 'Ok',
    cancel: 'Cancel',
  },
}

export function RMISOnboarding() {
  const { pathname, search } = useLocation()
  const history = useHistory()
  const [
    {
      carrier: { status: carrierStatus, documents_status: documentsStatus },
    },
  ] = useContext(LoadBoardContext)
  const isFeatureEnabled = useConfigContext().showOnboardingImprovements.toBoolean()
  const { finishOnboarding } = useMemo(() => qs.parse(search), [search])
  const { analytics } = useAnalytics()
  const needsFinishOnboarding = finishOnboarding === '1'
  const onboardingStep = useMemo(() => {
    return getOnboardingStep(carrierStatus, documentsStatus)
  }, [carrierStatus, documentsStatus])
  const {
    step: analyticsStep,
    confirm: analyticsConfirmAction,
    cancel: analyticsCancelAction,
  } = useMemo(() => analyticsLabels[onboardingStep], [onboardingStep])

  if (!isFeatureEnabled || !needsFinishOnboarding) return null

  function handleCancel() {
    analytics.track(['RMIS Finish Onboarding Dialog', analyticsStep, analyticsCancelAction])
    history.push(pathname)
  }

  function handleConfirm() {
    if (onboardingStep === OnboardingStep.Pending)
      window.open(process.env.REACT_APP_RMIS_ONBOARDING_URL)
    analytics.track(['RMIS Finish Onboarding Dialog', analyticsStep, analyticsConfirmAction])
    history.push(pathname)
  }

  return (
    <RMISOnboardingDialog onCancel={handleCancel} onConfirm={handleConfirm} step={onboardingStep} />
  )
}
